import { render, staticRenderFns } from "./userhead.vue?vue&type=template&id=4c5160c3&scoped=true"
import script from "./userhead.vue?vue&type=script&lang=js"
export * from "./userhead.vue?vue&type=script&lang=js"
import style0 from "./userhead.vue?vue&type=style&index=0&id=4c5160c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5160c3",
  null
  
)

export default component.exports